module.exports = __webpack_public_path__ + "img/feiman.1fe4b931.png";